import rp781 from "./rp781";
import rp782 from "./rp782";
import rp783 from "./rp783"; 
import rp784 from "./rp784";
import rp785 from "./rp785";
import rp786 from "./rp786";
import rp789 from "./rp789";

export default {
    rp781,
    rp782,
  rp783,
  rp784,
  rp785,
  rp786,
  rp789,
};